import React from 'react';
import { Container } from '@mui/material';
import AgentRequestList from '../components/RequestList';
import ResponsiveAppBar from '../layout/ResponsiveAppBar';
import TopMenu from '../layout/TopMenu';
import Footer from '../layout/Footer';

const RequestListPage = () => (
  <>
    <ResponsiveAppBar />
    <TopMenu />
    <Container maxWidth="xl">
      <AgentRequestList />
    </Container>
    <Footer />
  </>
);

export default RequestListPage;
